import { ApiError } from '@restaurant/api-client'

/**
 * Kimlik akışının kilitlenmesi ve çözümü.
 *
 * ## Ölçülen sorun
 *
 * Bir kullanıcı birden fazla işletmede çalışabilir (zincir danışmanı, ortak
 * muhasebeci). Sunucu bu durumda **tahmin etmiyor** ve doğru yapıyor: yanlış
 * tahmin, kullanıcının yanlış işletmede işlem yapması demek. Bunun yerine
 * `tenant_context_missing` dönüyor ve aktif işletmenin seçilmesini istiyor.
 *
 * Ölçüldü: iki işletmeye bağlı personel giriş yapıyor (201) ve ardından
 * panelin her ucu — `GET /session` dahil — 400 dönüyor. Seçim ucu aylardır
 * vardı ve çalışıyordu; eksik olan, seçeneklerin listesiydi.
 *
 * ## Neden PAYLAŞILAN pakette
 *
 * Aynı kilit üç uygulamada birden var: işletme paneli, POS ve KDS'in üçü de
 * personeli e-posta ve parolayla içeri alıyor. Üç kopya, "geçersiz token" ile
 * "işletme seçilmedi" ayrımının bir uygulamada düzeltilip diğerinde
 * unutulacağı gün demekti — ve o unutulan uygulamada kullanıcı yine sessizce
 * dışarı atılırdı.
 */
export interface SelectableTenant {
  readonly id: string
  readonly name: string
  readonly slug: string
}

/** `listSelectableTenants`'ın ihtiyaç duyduğu tek yetenek. */
export interface TenantChoiceClient {
  get<T>(path: string): Promise<{ readonly data: T }>
}

/**
 * Hata, "önce işletme seç" demek mi?
 *
 * Bu ayrım olmadan kusur şuydu: oturum yükleyicilerin `catch` bloğu HER
 * hatayı geçersiz token sayıp token'ı siliyordu. Kullanıcı giriş yapıyor,
 * sunucu haklı olarak seçim istiyor, istemci token'ı atıyor ve kişi hiçbir
 * açıklama görmeden giriş ekranına düşüyordu. Token gidince seçimi yapacak
 * kimlik de gittiği için kilit kendi kendini kilitliyordu.
 */
export function isTenantChoiceRequired(failure: unknown): boolean {
  return failure instanceof ApiError && failure.code === 'tenant_context_missing'
}

/**
 * Seçilebilecek işletmeleri okur.
 *
 * Uç tenant bağlamının DIŞINDA — olmak zorunda, çünkü kurulacak bağlam tam da
 * burada seçiliyor. Sunucu tarafında kapsam, kullanıcının kendi etkin
 * üyelikleriyle sınırlı (`member_tenant_rows` politikası).
 */
export async function listSelectableTenants(
  client: TenantChoiceClient,
): Promise<readonly SelectableTenant[]> {
  return (await client.get<readonly SelectableTenant[]>('/api/v1/session/tenants')).data
}
